export default from '../../components/header';



// WEBPACK FOOTER //
// ./app/containers/categories-page-header/categories-page-header.js